import { Divider, Grid } from "@mui/material";
import BarekamText from "../../../pages/components/text";
import logo from "../../../assets/logo.png";
import React, { useState } from "react";
import { OrderModel } from "../../../pages/shared/models/order/order-item.model";
import Message from "../../../pages/components/message";
import { MessageSections } from "../../../pages/components/message/message";
import { useAppSelector } from "../../../redux/store";
import moment from "moment";
import { SimpleTable } from "../styled";
import { ARMENIA_COUNTRY_ID } from "../../../constants";

export const OrderPaidExportTemplate = ({ order }: { order: OrderModel }) => {
  const { countries } = useAppSelector((state) => state.staticDataReducer);
  const { languageId } = useAppSelector((state) => state.messagesReducer);

  const [armeniaWarehouse] = useState(
    countries.find((country) => country.countryId === ARMENIA_COUNTRY_ID)
      ?.warehouse[0],
  );

  function getPrice() {
    if (order.paymentInfo?.appliedDiscount) {
      return (
        order.paymentInfo.shippingAmount - order.paymentInfo.appliedDiscount
      );
    } else if (order.paymentInfo?.appliedDiscountPercent) {
      return (
        (order.paymentInfo?.appliedDiscountPercent * 100) /
        order.paymentInfo.shippingAmount
      ).toFixed(2);
    } else {
      return order.paymentInfo?.shippingAmount;
    }
  }

  function getDiscount() {
    if (order.paymentInfo?.appliedDiscount) {
      return `${order.paymentInfo.appliedDiscount} ${order.paymentInfo?.shippingAmountCurrency?.name[languageId]}`;
    } else if (order.paymentInfo?.appliedDiscountPercent) {
      return order.paymentInfo?.appliedDiscountPercent + "%";
    } else {
      return 0;
    }
  }

  return (
    <Grid
      container
      width={"100%"}
      height={"100%"}
      padding={"3rem"}
      rowSpacing={"0.5rem"}
    >
      <Grid item xs={12}>
        <Divider style={{ width: "100%" }} />
      </Grid>

      <Grid item xs={12} display={"flex"} justifyContent={"space-between"}>
        <span />

        <span>
          <b>Delivery Invoice/Փոխադրման հաշիվ</b>
        </span>

        <img
          className={"logo"}
          src={logo}
          style={{ height: "1.5rem" }}
          alt={""}
        />
      </Grid>

      <Grid item xs={12} display={"flex"} justifyContent={"space-between"}>
        <div>
          <b>BILL TO</b>
          <br />
          {order.recipient.entityName ? (
            <>
              <br />
              {`${order.recipient.entityName}`}
            </>
          ) : (
            <>{`${order.recipient.firstName} ${order.recipient.lastName}`}</>
          )}
          <br />
          {`${order.recipient.passportOrIdSerialNumber}`}
          <br />
          {`+${order.recipient.phoneNumber}`}
          <br />
          {`${order.recipient.email}`}
          <br />
          {`${[
            order.recipient.country?.name[languageId],
            order.recipient.city?.name[languageId],
            order.recipient.province?.name[languageId],
            order.recipient.region?.name[languageId],
            order.recipient.street,
            order.recipient.building,
            order.recipient.entrance,
            order.recipient.floor,
            order.recipient.apartment,
          ]
            .filter((value) => !!value)
            .join(", ")}`}
        </div>

        <div>
          <Grid item xs={12} display={"flex"} justifyContent={"end"}>
            <div>
              <b>"B L S" LLC</b>
              <br />
              VAT No.: 00905916
              <br />
              {armeniaWarehouse?.addressLine1}
              <br />
              {armeniaWarehouse?.phone}
              <br />
              www.barekam.am
            </div>
          </Grid>
        </div>
      </Grid>

      <br />
      <br />
      <br />

      <Grid
        item
        xs={6}
        display={"flex"}
        justifyContent={"start"}
        style={{ marginTop: "40px" }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "left",
          }}
        >
          <div>
            <b>Invoice No</b> {order.internalTrackingNumber}
          </div>
          <div>
            <b>Date</b> {moment(moment.now()).format("DD/MM/YYYY")}
          </div>
        </div>
      </Grid>

      <br />

      <SimpleTable>
        <tr>
          <th>
            <BarekamText variant={"s"}>
              Ծառայության տեսակ / Item/Service
            </BarekamText>
          </th>
          <th>
            <BarekamText variant={"s"}>
              Բեռնագրի համար / Tracking number
            </BarekamText>
          </th>
          <th>
            <BarekamText variant={"s"}>Արժեք / Price</BarekamText>
          </th>
        </tr>
        <tr>
          <td>Shipping service / Փոխադրման ծառայություն</td>
          <td>{order.internalTrackingNumber}</td>
          <td>
            {order.products[0].price || 0}{" "}
            {order.products[0].currency.name[languageId]}
          </td>
        </tr>
      </SimpleTable>

      <Grid item xs={12} display={"flex"} justifyContent={"end"}>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "right",
          }}
        >
          <div style={{ textAlign: "right" }}>
            <b>Subtotal / Ըդնհանուր</b>
            {` ${order.paymentInfo?.shippingAmount} ${order.paymentInfo?.shippingAmountCurrency?.name[languageId]} `}
          </div>
          <div style={{ textAlign: "right" }}>
            <b>Discount/ Զեղչ</b> {`${getDiscount()}`}
          </div>
          <div style={{ textAlign: "right" }}>
            <b>TOTAL PAID / Վճարված</b>
            {` ${getPrice()} ${order.paymentInfo?.shippingAmountCurrency?.name[languageId]} `}
          </div>
        </div>
      </Grid>
    </Grid>
  );
};
